import { render, staticRenderFns } from "./SliceBigStatBanner.vue?vue&type=template&id=7dbd37a4&scoped=true"
import script from "./SliceBigStatBanner.vue?vue&type=script&lang=js"
export * from "./SliceBigStatBanner.vue?vue&type=script&lang=js"
import style0 from "./SliceBigStatBanner.vue?vue&type=style&index=0&id=7dbd37a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd37a4",
  null
  
)

export default component.exports